import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site-shell";
import { PricingCards } from "./index";
import { Check, X } from "lucide-react";

export const Route = createFileRoute("/pricing")({
  head: () => ({
    meta: [
      { title: "Pricing — DealDraft Pro · $19/month" },
      {
        name: "description",
        content:
          "DealDraft is free for 3 generations per month. Upgrade to Pro for $19/month for unlimited proposals and contracts.",
      },
      { property: "og:title", content: "Pricing — DealDraft" },
      {
        property: "og:description",
        content: "Free for 3 generations/month. $19/month for unlimited.",
      },
    ],
    links: [{ rel: "canonical", href: "https://dealdraft.pro/pricing" }],
  }),
  component: PricingPage,
});

const COMPARE: { label: string; free: boolean | string; pro: boolean | string }[] = [
  { label: "Generations per month", free: "3", pro: "Unlimited" },
  { label: "AI proposal + contract", free: true, pro: true },
  { label: "PDF download", free: true, pro: true },
  { label: "Document storage", free: false, pro: true },
  { label: "E-Signature", free: false, pro: "Coming soon" },
  { label: "Priority support", free: false, pro: true },
];

function PricingPage() {
  return (
    <SiteShell>
      <section className="mx-auto max-w-5xl px-6 pt-16 pb-12 text-center">
        <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">Simple, Honest Pricing</h1>
        <p className="mt-4 text-muted-foreground">
          Start free. Upgrade only when you need unlimited documents.
        </p>
        <PricingCards />
      </section>

      <section className="mx-auto max-w-4xl px-6 pb-20">
        <h2 className="text-2xl font-semibold tracking-tight">Compare plans</h2>
        <div className="mt-6 overflow-hidden rounded-xl border border-border">
          <table className="w-full text-sm">
            <thead className="bg-secondary/60 text-left">
              <tr>
                <th className="px-5 py-3 font-medium">Feature</th>
                <th className="px-5 py-3 font-medium">Free</th>
                <th className="px-5 py-3 font-medium">Pro</th>
              </tr>
            </thead>
            <tbody>
              {COMPARE.map((row) => (
                <tr key={row.label} className="border-t border-border">
                  <td className="px-5 py-3">{row.label}</td>
                  <td className="px-5 py-3">{renderCell(row.free)}</td>
                  <td className="px-5 py-3">{renderCell(row.pro)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </SiteShell>
  );
}

function renderCell(v: boolean | string) {
  if (v === true) return <Check className="h-4 w-4 text-accent" />;
  if (v === false) return <X className="h-4 w-4 text-muted-foreground" />;
  return <span className="font-medium">{v}</span>;
}
